import { InjectionToken } from '@angular/core';

export const WS_PATH = new InjectionToken<string>('wsPath');

